module.exports = __webpack_public_path__ + "img/_icon-prices.f1238c19.svg";